export const THEMES = {
  default: {
    id: 'default',
    name: 'Clean White',
    preview: { bg: '#ffffff', card: '#f8f9fa', text: '#1a1a2e', accent: '#4361ee' },
    styles: {
      '--theme-bg': '#ffffff',
      '--theme-bg-secondary': '#f8f9fa',
      '--theme-card': '#ffffff',
      '--theme-card-border': '#e5e7eb',
      '--theme-text': '#1a1a2e',
      '--theme-text-muted': '#6b7280',
      '--theme-accent': '#4361ee',
      '--theme-accent-text': '#ffffff',
      '--theme-link-bg': '#ffffff',
      '--theme-link-hover': '#f0f4ff',
      '--theme-link-border': '#e5e7eb',
      '--theme-gradient': 'linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)',
    }
  },
  midnight: {
    id: 'midnight',
    name: 'Midnight',
    preview: { bg: '#0f0f23', card: '#1a1a3e', text: '#e0e0ff', accent: '#7c3aed' },
    styles: {
      '--theme-bg': '#0f0f23',
      '--theme-bg-secondary': '#1a1a3e',
      '--theme-card': '#1a1a3e',
      '--theme-card-border': '#2d2d5e',
      '--theme-text': '#e0e0ff',
      '--theme-text-muted': '#8888bb',
      '--theme-accent': '#7c3aed',
      '--theme-accent-text': '#ffffff',
      '--theme-link-bg': '#1a1a3e',
      '--theme-link-hover': '#252552',
      '--theme-link-border': '#2d2d5e',
      '--theme-gradient': 'linear-gradient(135deg, #0f0f23 0%, #1a1a3e 100%)',
    }
  },
  ocean: {
    id: 'ocean',
    name: 'Ocean Breeze',
    preview: { bg: '#0a192f', card: '#112240', text: '#ccd6f6', accent: '#64ffda' },
    styles: {
      '--theme-bg': '#0a192f',
      '--theme-bg-secondary': '#112240',
      '--theme-card': '#112240',
      '--theme-card-border': '#1d3557',
      '--theme-text': '#ccd6f6',
      '--theme-text-muted': '#8892b0',
      '--theme-accent': '#64ffda',
      '--theme-accent-text': '#0a192f',
      '--theme-link-bg': '#112240',
      '--theme-link-hover': '#1a3050',
      '--theme-link-border': '#1d3557',
      '--theme-gradient': 'linear-gradient(135deg, #0a192f 0%, #112240 100%)',
    }
  },
  sunset: {
    id: 'sunset',
    name: 'Sunset Glow',
    preview: { bg: '#1a0a2e', card: '#2d1b4e', text: '#f0e6ff', accent: '#ff6b6b' },
    styles: {
      '--theme-bg': '#1a0a2e',
      '--theme-bg-secondary': '#2d1b4e',
      '--theme-card': '#2d1b4e',
      '--theme-card-border': '#4a2d6e',
      '--theme-text': '#f0e6ff',
      '--theme-text-muted': '#b8a0d0',
      '--theme-accent': '#ff6b6b',
      '--theme-accent-text': '#ffffff',
      '--theme-link-bg': '#2d1b4e',
      '--theme-link-hover': '#3d2b5e',
      '--theme-link-border': '#4a2d6e',
      '--theme-gradient': 'linear-gradient(135deg, #1a0a2e 0%, #2d1b4e 50%, #4a1942 100%)',
    }
  },
  forest: {
    id: 'forest',
    name: 'Forest',
    preview: { bg: '#0d1f0d', card: '#1a3a1a', text: '#d4e8d4', accent: '#4ade80' },
    styles: {
      '--theme-bg': '#0d1f0d',
      '--theme-bg-secondary': '#1a3a1a',
      '--theme-card': '#1a3a1a',
      '--theme-card-border': '#2d5a2d',
      '--theme-text': '#d4e8d4',
      '--theme-text-muted': '#88b888',
      '--theme-accent': '#4ade80',
      '--theme-accent-text': '#0d1f0d',
      '--theme-link-bg': '#1a3a1a',
      '--theme-link-hover': '#254a25',
      '--theme-link-border': '#2d5a2d',
      '--theme-gradient': 'linear-gradient(135deg, #0d1f0d 0%, #1a3a1a 100%)',
    }
  },
  neon: {
    id: 'neon',
    name: 'Neon Nights',
    preview: { bg: '#0a0a0a', card: '#1a1a1a', text: '#ffffff', accent: '#00ff88' },
    styles: {
      '--theme-bg': '#0a0a0a',
      '--theme-bg-secondary': '#1a1a1a',
      '--theme-card': '#1a1a1a',
      '--theme-card-border': '#333333',
      '--theme-text': '#ffffff',
      '--theme-text-muted': '#999999',
      '--theme-accent': '#00ff88',
      '--theme-accent-text': '#0a0a0a',
      '--theme-link-bg': '#1a1a1a',
      '--theme-link-hover': '#252525',
      '--theme-link-border': '#333333',
      '--theme-gradient': 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)',
    }
  },
  candy: {
    id: 'candy',
    name: 'Cotton Candy',
    preview: { bg: '#fdf2f8', card: '#ffffff', text: '#831843', accent: '#ec4899' },
    styles: {
      '--theme-bg': '#fdf2f8',
      '--theme-bg-secondary': '#fce7f3',
      '--theme-card': '#ffffff',
      '--theme-card-border': '#f9a8d4',
      '--theme-text': '#831843',
      '--theme-text-muted': '#be185d',
      '--theme-accent': '#ec4899',
      '--theme-accent-text': '#ffffff',
      '--theme-link-bg': '#ffffff',
      '--theme-link-hover': '#fdf2f8',
      '--theme-link-border': '#f9a8d4',
      '--theme-gradient': 'linear-gradient(135deg, #fdf2f8 0%, #fce7f3 50%, #fbcfe8 100%)',
    }
  },
  slate: {
    id: 'slate',
    name: 'Warm Slate',
    preview: { bg: '#1c1917', card: '#292524', text: '#fafaf9', accent: '#f59e0b' },
    styles: {
      '--theme-bg': '#1c1917',
      '--theme-bg-secondary': '#292524',
      '--theme-card': '#292524',
      '--theme-card-border': '#44403c',
      '--theme-text': '#fafaf9',
      '--theme-text-muted': '#a8a29e',
      '--theme-accent': '#f59e0b',
      '--theme-accent-text': '#1c1917',
      '--theme-link-bg': '#292524',
      '--theme-link-hover': '#3a3633',
      '--theme-link-border': '#44403c',
      '--theme-gradient': 'linear-gradient(135deg, #1c1917 0%, #292524 100%)',
    }
  },
  // ==================== NEW THEMES ====================
  cherry: {
    id: 'cherry',
    name: 'Cherry Blossom',
    preview: { bg: '#fff5f5', card: '#ffffff', text: '#4a0e0e', accent: '#e11d48' },
    styles: {
      '--theme-bg': '#fff5f5',
      '--theme-bg-secondary': '#ffe4e6',
      '--theme-card': '#ffffff',
      '--theme-card-border': '#fda4af',
      '--theme-text': '#4a0e0e',
      '--theme-text-muted': '#9f1239',
      '--theme-accent': '#e11d48',
      '--theme-accent-text': '#ffffff',
      '--theme-link-bg': '#ffffff',
      '--theme-link-hover': '#fff1f2',
      '--theme-link-border': '#fecdd3',
      '--theme-gradient': 'linear-gradient(135deg, #fff5f5 0%, #ffe4e6 50%, #fecdd3 100%)',
    }
  },
  arctic: {
    id: 'arctic',
    name: 'Arctic Frost',
    preview: { bg: '#f0f9ff', card: '#ffffff', text: '#0c4a6e', accent: '#0ea5e9' },
    styles: {
      '--theme-bg': '#f0f9ff',
      '--theme-bg-secondary': '#e0f2fe',
      '--theme-card': '#ffffff',
      '--theme-card-border': '#7dd3fc',
      '--theme-text': '#0c4a6e',
      '--theme-text-muted': '#0369a1',
      '--theme-accent': '#0ea5e9',
      '--theme-accent-text': '#ffffff',
      '--theme-link-bg': '#ffffff',
      '--theme-link-hover': '#f0f9ff',
      '--theme-link-border': '#bae6fd',
      '--theme-gradient': 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 50%, #bae6fd 100%)',
    }
  },
  cyberpunk: {
    id: 'cyberpunk',
    name: 'Cyberpunk',
    preview: { bg: '#0d0d0d', card: '#1a1a2e', text: '#e0e0ff', accent: '#f72585' },
    styles: {
      '--theme-bg': '#0d0d0d',
      '--theme-bg-secondary': '#1a1a2e',
      '--theme-card': '#1a1a2e',
      '--theme-card-border': '#2d2d5e',
      '--theme-text': '#e0e0ff',
      '--theme-text-muted': '#9090cc',
      '--theme-accent': '#f72585',
      '--theme-accent-text': '#ffffff',
      '--theme-link-bg': '#1a1a2e',
      '--theme-link-hover': '#252545',
      '--theme-link-border': '#3a3a6e',
      '--theme-gradient': 'linear-gradient(135deg, #0d0d0d 0%, #1a1a2e 50%, #16213e 100%)',
    }
  },
  lavender: {
    id: 'lavender',
    name: 'Lavender Dream',
    preview: { bg: '#f5f3ff', card: '#ffffff', text: '#3b0764', accent: '#8b5cf6' },
    styles: {
      '--theme-bg': '#f5f3ff',
      '--theme-bg-secondary': '#ede9fe',
      '--theme-card': '#ffffff',
      '--theme-card-border': '#c4b5fd',
      '--theme-text': '#3b0764',
      '--theme-text-muted': '#6d28d9',
      '--theme-accent': '#8b5cf6',
      '--theme-accent-text': '#ffffff',
      '--theme-link-bg': '#ffffff',
      '--theme-link-hover': '#f5f3ff',
      '--theme-link-border': '#ddd6fe',
      '--theme-gradient': 'linear-gradient(135deg, #f5f3ff 0%, #ede9fe 50%, #ddd6fe 100%)',
    }
  },
  ember: {
    id: 'ember',
    name: 'Ember',
    preview: { bg: '#1a0800', card: '#2d1400', text: '#fde8d0', accent: '#f97316' },
    styles: {
      '--theme-bg': '#1a0800',
      '--theme-bg-secondary': '#2d1400',
      '--theme-card': '#2d1400',
      '--theme-card-border': '#5c2d00',
      '--theme-text': '#fde8d0',
      '--theme-text-muted': '#c8956a',
      '--theme-accent': '#f97316',
      '--theme-accent-text': '#ffffff',
      '--theme-link-bg': '#2d1400',
      '--theme-link-hover': '#3d2000',
      '--theme-link-border': '#5c2d00',
      '--theme-gradient': 'linear-gradient(135deg, #1a0800 0%, #2d1400 50%, #3d1e00 100%)',
    }
  },
  mint: {
    id: 'mint',
    name: 'Fresh Mint',
    preview: { bg: '#f0fdf4', card: '#ffffff', text: '#14532d', accent: '#22c55e' },
    styles: {
      '--theme-bg': '#f0fdf4',
      '--theme-bg-secondary': '#dcfce7',
      '--theme-card': '#ffffff',
      '--theme-card-border': '#86efac',
      '--theme-text': '#14532d',
      '--theme-text-muted': '#15803d',
      '--theme-accent': '#22c55e',
      '--theme-accent-text': '#ffffff',
      '--theme-link-bg': '#ffffff',
      '--theme-link-hover': '#f0fdf4',
      '--theme-link-border': '#bbf7d0',
      '--theme-gradient': 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 50%, #bbf7d0 100%)',
    }
  },
  cosmos: {
    id: 'cosmos',
    name: 'Cosmos',
    preview: { bg: '#0c0118', card: '#1a0530', text: '#e8d5ff', accent: '#a855f7' },
    styles: {
      '--theme-bg': '#0c0118',
      '--theme-bg-secondary': '#1a0530',
      '--theme-card': '#1a0530',
      '--theme-card-border': '#3b0f60',
      '--theme-text': '#e8d5ff',
      '--theme-text-muted': '#a078d0',
      '--theme-accent': '#a855f7',
      '--theme-accent-text': '#ffffff',
      '--theme-link-bg': '#1a0530',
      '--theme-link-hover': '#250a40',
      '--theme-link-border': '#3b0f60',
      '--theme-gradient': 'linear-gradient(135deg, #0c0118 0%, #1a0530 50%, #0f172a 100%)',
    }
  },
  retro: {
    id: 'retro',
    name: 'Retro Cream',
    preview: { bg: '#fef9ef', card: '#fffdf5', text: '#422006', accent: '#ca8a04' },
    styles: {
      '--theme-bg': '#fef9ef',
      '--theme-bg-secondary': '#fef3c7',
      '--theme-card': '#fffdf5',
      '--theme-card-border': '#fcd34d',
      '--theme-text': '#422006',
      '--theme-text-muted': '#92400e',
      '--theme-accent': '#ca8a04',
      '--theme-accent-text': '#ffffff',
      '--theme-link-bg': '#fffdf5',
      '--theme-link-hover': '#fef9ef',
      '--theme-link-border': '#fde68a',
      '--theme-gradient': 'linear-gradient(135deg, #fef9ef 0%, #fef3c7 50%, #fde68a 100%)',
    }
  },
  graphite: {
    id: 'graphite',
    name: 'Graphite',
    preview: { bg: '#111111', card: '#1e1e1e', text: '#e5e5e5', accent: '#71717a' },
    styles: {
      '--theme-bg': '#111111',
      '--theme-bg-secondary': '#1e1e1e',
      '--theme-card': '#1e1e1e',
      '--theme-card-border': '#333333',
      '--theme-text': '#e5e5e5',
      '--theme-text-muted': '#a3a3a3',
      '--theme-accent': '#71717a',
      '--theme-accent-text': '#ffffff',
      '--theme-link-bg': '#1e1e1e',
      '--theme-link-hover': '#2a2a2a',
      '--theme-link-border': '#333333',
      '--theme-gradient': 'linear-gradient(135deg, #111111 0%, #1e1e1e 100%)',
    }
  },
  // ---- Pro v2 themes ----
  stage: {
    id: 'stage',
    name: 'Stage',
    pro: true,
    preview: { bg: '#080A0F', card: '#0F1218', text: '#FFFFFF', accent: '#0055FF' },
    styles: {
      '--theme-bg': '#080A0F',
      '--theme-bg-secondary': '#0F1218',
      '--theme-card': 'rgba(255,255,255,0.05)',
      '--theme-card-border': 'rgba(255,255,255,0.10)',
      '--theme-text': '#FFFFFF',
      '--theme-text-muted': 'rgba(255,255,255,0.55)',
      '--theme-accent': '#0055FF',
      '--theme-accent-text': '#FFFFFF',
      '--theme-link-bg': 'rgba(255,255,255,0.05)',
      '--theme-link-hover': 'rgba(255,255,255,0.10)',
      '--theme-link-border': 'rgba(255,255,255,0.10)',
      '--theme-gradient': 'radial-gradient(ellipse at 50% 0%, #14182a 0%, #080A0F 60%)',
    }
  },
  neonTokyo: {
    id: 'neonTokyo',
    name: 'Neon Tokyo',
    pro: true,
    preview: { bg: '#0a0014', card: '#1a0028', text: '#fff0fb', accent: '#ff2bd6' },
    styles: {
      '--theme-bg': '#0a0014',
      '--theme-bg-secondary': '#1a0028',
      '--theme-card': '#1a0028',
      '--theme-card-border': '#ff2bd650',
      '--theme-text': '#fff0fb',
      '--theme-text-muted': '#c084fc',
      '--theme-accent': '#ff2bd6',
      '--theme-accent-text': '#0a0014',
      '--theme-link-bg': '#1a0028',
      '--theme-link-hover': '#2a0040',
      '--theme-link-border': '#ff2bd680',
      '--theme-gradient': 'linear-gradient(135deg, #0a0014 0%, #1a0028 50%, #2a0040 100%)',
    }
  },
  vintagePolaroid: {
    id: 'vintagePolaroid',
    name: 'Vintage Polaroid',
    pro: true,
    preview: { bg: '#f3ead5', card: '#fdf7e3', text: '#4a3520', accent: '#b8693c' },
    styles: {
      '--theme-bg': '#f3ead5',
      '--theme-bg-secondary': '#fdf7e3',
      '--theme-card': '#fdf7e3',
      '--theme-card-border': '#d4a574',
      '--theme-text': '#4a3520',
      '--theme-text-muted': '#8a6a4a',
      '--theme-accent': '#b8693c',
      '--theme-accent-text': '#fdf7e3',
      '--theme-link-bg': '#fdf7e3',
      '--theme-link-hover': '#f5e6c8',
      '--theme-link-border': '#d4a574',
      '--theme-gradient': 'linear-gradient(135deg, #f3ead5 0%, #fdf7e3 50%, #f5e6c8 100%)',
    }
  }
};

export const THEME_LIST = Object.values(THEMES);

export function getTheme(themeId) {
  return THEMES[themeId] || THEMES.default;
}
